import * as React from 'react';
import style from './WTableFilterMultiSelect.less';
import * as classNames from 'classnames';

interface WTableFilterMultiselectProps extends React.ClassAttributes<any> {
    values: Array<any>;
    className?: string;
    stampResetFilter?: number;
    attr?: any;
    disableFilter?: boolean;
    onSelectionChange: (selected: any) => void;
}

interface WTableFilterMultiselectState {
    selectList: any;
    filterString: string;
    filterVisible: boolean;
    checkedToggleFilter: boolean;
}

export class WTableFilterMultiselect extends React.Component<WTableFilterMultiselectProps, WTableFilterMultiselectState> {
    constructor(props: any) {
        super(props);
        this.state = {
            filterVisible: false,
            filterString: '',
            selectList: this.getSelectList(),
            checkedToggleFilter: false
        };

        this.onFilterChange = this.onFilterChange.bind(this);
        this.toggleAll = this.toggleAll.bind(this);
        this.toggleFiltered = this.toggleFiltered.bind(this);
        this.toggleValue = this.toggleValue.bind(this);
    }

    private refWrapper: any = React.createRef();

    componentDidUpdate(prevProps: Readonly<WTableFilterMultiselectProps>) {
        if (prevProps.stampResetFilter !== this.props.stampResetFilter) {
            this.setState({ selectList: this.getSelectList() });
        }
    }

    getSelectList() {
        const selected: any = {}
        if (Array.isArray(this.props.values) && this.props.values.length > 0) {
            this.props.values.forEach((val: any) => selected[val + ''] = true)
        }
        return selected;
    }

    render() {
        const { selectList } = this.state;

        let checkedAll;
        if (Object.keys(selectList).find((val: string) => selectList[val] === false)) {
            checkedAll = false;
        } else {
            checkedAll = true;
        }

        let styleSticky: React.CSSProperties = {};
        if (this.props.className && this.props.className === 'sticky' && this.refWrapper && this.refWrapper.current) {
            styleSticky = { top: 0, left: this.refWrapper.current.clientWidth };
        }

        const attr = this.props.attr;
        const fieldType = attr && attr.TYPE ? attr.TYPE : null;
        const escape_0 = attr && attr.FILTER_ESCAPE_0 ? attr.FILTER_ESCAPE_0 : null;
        const opts = attr && attr.OPTS ? attr.OPTS : [];
        const arrow = require('../../../icons/down-arrowhead.svg');
        const checkedCnt = Object.keys(selectList).filter((val: string) => selectList[val] === true).length;

        return (
            <div
                ref={this.refWrapper}
                onMouseEnter={() => this.setState({ filterVisible: true })}
                onMouseLeave={() => this.setState({ filterVisible: false })}
                className={style.wrapper}
            >
                <div className={style.info} style={{ backgroundColor: (checkedAll ? 'transparent' : '#e4eaf3') }}>
                    <span style={{ fontStyle: 'italic', margin: 'auto 0' }}>
                        {checkedAll ? 'Alle' : checkedCnt + ' ausgewählt'}
                    </span>
                    <img src={arrow} style={{ width: 9 }} alt='' />
                </div>
                {this.state.filterVisible ?
                    <div className={style.floatbox} style={styleSticky}>
                        {!this.props.disableFilter && <div>
                            <input
                                style={{ paddingLeft: 10, width: '80%' }}
                                placeholder='Suche'
                                type='Text'
                                value={this.state.filterString}
                                onChange={(e: any) => this.onFilterChange(e.target.value)}
                            />
                            <span
                                style={{ marginLeft: -15, color: 'gray', fontSize: '0.8em', padding: 2, cursor: 'pointer' }}
                                onClick={() => this.onFilterChange('')}
                            >
                                {String.fromCharCode(10005)}
                            </span>
                        </div>}
                        <div style={{ borderTop: '1px gray solid', borderBottom: '1px gray solid', margin: '5px 0', padding: '5px 0' }}>
                            <div className={style.list}>
                                {Object.keys(selectList)
                                    .filter((v) => !this.state.filterString || this.state.filterString === '' || (v + '').toLowerCase().indexOf(this.state.filterString.toLowerCase()) > -1)
                                    .map((v) => {
                                        let showVal = v;
                                        if (parseInt(v, 10) === 0 && escape_0) {
                                            showVal = escape_0;
                                        } else if (opts.length > 0) {
                                            const fnd = opts.find((o: any) => o.VALUE === v || (typeof o.VALUE === 'number' && o.VALUE === +v));
                                            if (fnd && fnd.TITEL) {
                                                showVal = fnd.TITEL;
                                            }
                                        } else if (((fieldType === 'DATETIME' || fieldType === 'DATE') || v === '0') || v === null) {
                                            showVal = '(leer)';
                                        }
                                        return <div key={'choice_' + v} className={style.listItem}>
                                            <input
                                                type='checkbox'
                                                value={v === null ? 'null' : v}
                                                checked={this.state.selectList[v + '']}
                                                onChange={(e: any) => {
                                                    const value = e.target.value + '';
                                                    const checked = e.target.checked;
                                                    this.toggleValue(value, checked);
                                                }}
                                            />
                                            {showVal}
                                        </div>;
                                    })}
                            </div>
                        </div>
                        <div className={classNames(style.listItem, style.textsmallblue)}>
                            <input
                                type='checkbox'
                                onChange={(e: any) => this.toggleAll(e.target.checked)}
                                checked={checkedAll}
                            /> Alle auswählen/entfernen
                        </div>
                        {!this.props.disableFilter &&
                            <div className={classNames(style.listItem, style.textsmallblue)}>
                                <input
                                    type='checkbox'
                                    onChange={(e: any) => this.toggleFiltered(e.target.checked)}
                                    checked={this.state.checkedToggleFilter}
                                    disabled={!this.state.filterString || this.state.filterString === ''}
                                /> Gewählte auswählen/entfernen
                            </div>
                        }
                    </div> : ' '
                }
            </div>
        );
    }

    toggleAll(checked: boolean, bytoggleFiltered?: boolean) {
        if (!bytoggleFiltered && !checked) {
            this.setState({ checkedToggleFilter: false });
        }

        const { selectList } = this.state;
        let needUpdate = false;
        Object.keys(selectList).forEach((val: string) => {
            if (selectList[val] !== checked) {
                selectList[val] = checked;
                needUpdate = true;
            }
        });
        if (needUpdate) {
            this.setState({ selectList });
            const selected = Object.keys(selectList).filter((val: string) => selectList[val] === true);
            this.props.onSelectionChange(selected);
        }
    }

    toggleFiltered(checked: boolean) {
        this.setState({ checkedToggleFilter: checked });
        if (checked) {
            this.toggleAll(false, true);
        }

        const { selectList } = this.state;
        let needUpdate = false;
        Object.keys(selectList)
            .filter((val: string) => !this.state.filterString || this.state.filterString === '' || val.toLowerCase().indexOf(this.state.filterString.toLowerCase()) > -1)
            .forEach((val: string) => {
                if (selectList[val] !== checked) {
                    selectList[val] = checked;
                    needUpdate = true;
                }
            });
        if (needUpdate) {
            this.setState({ selectList });
            const selected = Object.keys(selectList).filter((val: string) => selectList[val] === true);
            this.props.onSelectionChange(selected);
        }
    }

    onFilterChange(filterString: string) {
        this.setState({ filterString, checkedToggleFilter: false });
    }

    toggleValue(value: string, checked: boolean) {
        const { selectList } = this.state;
        if (selectList[value] !== checked) {
            selectList[value] = checked
            this.setState({ selectList });
            const selected = Object.keys(selectList).filter((val: string) => selectList[val] === true);
            this.props.onSelectionChange(selected);
        }
    }
}
